<div class="form-group" [class.valid]="isValid" [class.icon-input-container]="!!icon" [class.error]="isValid === false">
  @if (fixedLabel) {
    <ng-container *ngTemplateOutlet="zeroInput; context: { labelType: 'fixed' }" />
  } @else {
    <ng-container *ngTemplateOutlet="zeroInput; context: { labelType: 'floating' }" />
  }

  @if (type === 'password') {
    <web-design-system-icon [name]="isPasswordVisible ? 'eye-1' : 'eye'" color="dimmed" (click)="isPasswordVisible = !isPasswordVisible" />
  }
  @if (icon) {
    <web-design-system-icon [name]="icon" color="dimmed" />
  }
  @if (error) {
    <div data-zid="error-message-pass" class="zero-text p-xsmall-reg course-red mt-1">{{ error }}</div>
  }
</div>

<ng-template #zeroInput let-labelType="labelType">
  @if (isCurrency) {
    <input
      zeroCurrencyInput
      #input
      [class]="labelType + (fixedLabel ? ' padding-left-' + fixedLabel.length : '')"
      [name]="labelType + '-label'"
      [disabled]="disabled"
      [type]="isPasswordVisible ? 'text' : type"
      [placeholder]="label"
      [ngModel]="value"
      [autocomplete]="autocomplete ? 'on' : 'off'"
      (wheel)="$event.preventDefault()"
      (ngModelChange)="valueChange.emit($event)"
      (blur)="handleBlur.emit(value)"
    />
  } @else {
    <input
      #input
      [class]="labelType + (fixedLabel ? ' padding-left-' + fixedLabel.length : '')"
      [name]="labelType + '-label'"
      [disabled]="disabled"
      [type]="isPasswordVisible ? 'text' : type"
      [placeholder]="label"
      [ngModel]="value"
      [autocomplete]="autocomplete ? 'on' : 'off'"
      (wheel)="$event.preventDefault()"
      (ngModelChange)="valueChange.emit($event)"
      (blur)="handleBlur.emit(value)"
    />
  }

  <label [for]="labelType + '-label'" [class]="labelSize">{{ fixedLabel ?? label }}</label>
</ng-template>
